import { render, staticRenderFns } from "./PageSettingsContext.vue?vue&type=template&id=066c8d17&scoped=true"
import script from "./PageSettingsContext.vue?vue&type=script&lang=js"
export * from "./PageSettingsContext.vue?vue&type=script&lang=js"
import style0 from "./PageSettingsContext.vue?vue&type=style&index=0&id=066c8d17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c8d17",
  null
  
)

export default component.exports